const color = {
  white: '#ffffff',
  primary: '#ff4400',
  primaryLight: 'rgba(255, 68, 0, 0.08)',
  textGray: '#475467',
  dark: '#101828',
  border: '#eaecf0',
};

export default color;
